import { useContext } from "react";
import { isEmpty } from "ramda";

import { FaceOrgContext } from "contexts/faceorg-context";
import { trackEventFaceOrg } from "utils/gAnalyticsUtils";

const useFaceOrg = () => {
  const { entryPoint, setEntryPoint } = useContext(FaceOrgContext);

  const clearEntryPoint = () => {
    setEntryPoint("");
  };

  const trackFaceOrg = (user, relation, hasMoreFaces = false) => {
    trackEventFaceOrg(user, !isEmpty(relation) ? relation : "none", entryPoint);
    if (!hasMoreFaces) clearEntryPoint();
  };

  return { entryPoint, setEntryPoint, clearEntryPoint, trackFaceOrg };
};

export default useFaceOrg;
